var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-item",
    {
      staticClass: "customer-card__note q-py-md q-px-md",
      attrs: { disabled: _vm.isDisabled, multiline: "" }
    },
    [
      _c(
        "q-item-side",
        [
          _c("user-avatar", {
            attrs: { user: _vm.author, height: "38px", width: "38px" }
          })
        ],
        1
      ),
      _c(
        "q-item-main",
        [
          _c("q-item-tile", { attrs: { label: "", lines: "1" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.noteAuthor) +
                " " +
                _vm._s(_vm.isOwner ? "(" + _vm.$t("you") + ")" : "") +
                "\n      "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.note.is_private,
                    expression: "note.is_private"
                  }
                ]
              },
              [_vm._v("· " + _vm._s(_vm.$t("private")))]
            )
          ]),
          _c(
            "q-item-tile",
            { staticClass: "q-mt-sm", attrs: { sublabel: "" } },
            [
              !_vm.editing
                ? [
                    _c("span", { staticClass: "pre-wrap" }, [
                      _vm._v(_vm._s(_vm.note.text))
                    ]),
                    _c("div", { staticClass: "lt-md q-mt-sm text-light" }, [
                      _c(
                        "span",
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.timestamp) +
                              "\n            "
                          ),
                          _c(
                            "q-tooltip",
                            {
                              attrs: {
                                anchor: "top middle",
                                self: "bottom middle",
                                delay: 300,
                                offset: [0, 5]
                              }
                            },
                            [_vm._v(_vm._s(_vm.date))]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                : [
                    _c("expandable-textarea", {
                      ref: "editTextarea",
                      attrs: {
                        classes: ["block", "full-width"],
                        placeholder: _vm.$t("write_note"),
                        expanded: ""
                      },
                      model: {
                        value: _vm.editText,
                        callback: function($$v) {
                          _vm.editText = $$v
                        },
                        expression: "editText"
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "row justify-end q-mt-sm" },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              color: "white",
                              "text-color": "light"
                            },
                            on: { click: _vm.handleCancelEdit }
                          },
                          [_vm._v(_vm._s(_vm.$t("cancel")))]
                        ),
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              color: "white",
                              "text-color": "faded"
                            },
                            on: { click: _vm.handleSaveEdit }
                          },
                          [_vm._v(_vm._s(_vm.$t("save")))]
                        )
                      ],
                      1
                    )
                  ]
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "row items-center absolute text-light",
              staticStyle: {
                "margin-right": "24px",
                "margin-top": "16px",
                top: "0",
                right: "0"
              }
            },
            [
              _c(
                "span",
                { staticClass: "gt-sm" },
                [
                  _vm._v("\n        " + _vm._s(_vm.timestamp) + "\n        "),
                  _c(
                    "q-tooltip",
                    {
                      attrs: {
                        anchor: "top middle",
                        self: "bottom middle",
                        delay: 300,
                        offset: [0, 5]
                      }
                    },
                    [_vm._v(_vm._s(_vm.date))]
                  )
                ],
                1
              ),
              _vm.isOwner
                ? _c(
                    "q-icon",
                    {
                      staticClass: "on-right",
                      attrs: {
                        name: "more_horiz",
                        color: "light",
                        size: "1.25rem"
                      }
                    },
                    [
                      _c(
                        "q-popover",
                        [
                          _c(
                            "q-list",
                            { attrs: { "item-separator": "", link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleTogglePrivate($event)
                                    }
                                  }
                                },
                                [
                                  _c("q-item-main", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.toggleVisibilityText))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _c("q-item-separator"),
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleEdit($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item-side",
                                    [_c("q-icon", { attrs: { name: "edit" } })],
                                    1
                                  ),
                                  _c("q-item-main", [
                                    _c("span", [_vm._v(_vm._s(_vm.$t("edit")))])
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleDelete($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item-side",
                                    [
                                      _c("q-icon", {
                                        attrs: { name: "delete" }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("q-item-main", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("delete")))
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }